module.exports = __webpack_public_path__ + "img/guileme-3.ca5ee44f.png";